import React from 'react'
import { useLocation } from 'react-router-dom';

const RazorPayCheckout = ({response}) => {
  const location = useLocation();
  const responseData = location.state?.responseData;

  return (
    <div dangerouslySetInnerHTML={{ __html: responseData }} ></div>
  )
}

export default RazorPayCheckout